<template>
  <v-container fluid grid-list-xl text-xs-center class="container-top-margin">
    <v-layout row justify-space-around wrap subheading>
      <v-flex md2 xs10>
        <v-btn block color="blue darken-1" dark class="elevation-5" v-on:click="goTo('/clientes')">Clientes</v-btn>
      </v-flex>
      <v-flex md2 xs10>
        <v-btn block color="amber darken-3" dark class="elevation-5" v-on:click="goTo('/carros')">Carros</v-btn>
      </v-flex>
      <v-flex md2 xs10>
        <v-btn block color="teal darken-1" dark class="elevation-5">Serviços</v-btn>
      </v-flex>
      <v-flex md2 xs10>
        <v-btn block color="red darken-4" dark class="elevation-5">Pagamentos</v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "Dashboard",
  methods: {
    goTo(str_path) {
      this.$router.push({ path: str_path });
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/mecanica/Dashboard.vue